var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-overview" },
    [
      _c("div", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("dashboard.overview")) + " "),
      ]),
      _c("BalancePanel"),
      _c("TotalTransactionDataPannelAgent", {
        on: { changeShowType: _vm.changeShowType },
      }),
      _c("div", { staticClass: "transaction-trends-container" }, [
        _c(
          "div",
          { staticClass: "bar-container" },
          [
            _c(
              "div",
              { staticClass: "text-title" },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("dashboard.transaction_trends")) + " "
                ),
                _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("tips.current_time_zone"))),
                    ]),
                  ]),
                  _c(
                    "span",
                    [
                      _c("svg-icon", {
                        staticStyle: {
                          width: "22px",
                          color: "#0058CF",
                          cursor: "pointer",
                        },
                        attrs: { "icon-class": "icon-font-warning" },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c("bar-chart", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { "char-data": _vm.charData },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "data-container" },
          [
            _c("div", { staticClass: "text-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("components.filter")) + " "),
            ]),
            _c(
              "div",
              {
                staticClass: "filter-item",
                staticStyle: { "margin-bottom": "12px", "margin-top": "24px" },
              },
              [
                _c("span", { staticClass: "filter-label" }, [
                  _vm._v(_vm._s(_vm.$t("components.date"))),
                ]),
                _c(
                  "el-select",
                  {
                    staticClass: "search-frame mb-10",
                    attrs: { clearable: "" },
                    on: { change: _vm.onClickchangeTimes },
                    model: {
                      value: _vm.activeColor,
                      callback: function ($$v) {
                        _vm.activeColor = $$v
                      },
                      expression: "activeColor",
                    },
                  },
                  _vm._l(_vm.dateArr, function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "filter-item",
                staticStyle: { "margin-bottom": "24px" },
              },
              [
                _c("span", { staticClass: "filter-label" }, [
                  _vm._v(_vm._s(_vm.$t("components.view"))),
                ]),
                _c(
                  "el-select",
                  {
                    staticClass: "search-frame",
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.showType,
                      callback: function ($$v) {
                        _vm.showType = $$v
                      },
                      expression: "showType",
                    },
                  },
                  _vm._l(
                    _vm.showTypeTransaction === "second"
                      ? _vm.transaction_payin
                      : _vm.transaction,
                    function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }
                  ),
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticClass: "btn-search mb-10",
                attrs: {
                  type: "primary",
                  size: "small",
                  icon: "el-icon-search",
                },
                on: { click: _vm.getCharData },
              },
              [_vm._v(_vm._s(_vm.$t("components.search")))]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }